import * as React from 'react'
import styled from 'styled-components'
import TitleCard from '../TitleCard/TitleCard'
import { colors } from '../../utils/colors'

// @ts-ignore
const hasClipboardApi = navigator.clipboard

const { Button, toaster } = require('evergreen-ui')
const toasterOptions = { duration: 2, id: 'unique-toaster' }

class ErrorLog extends React.Component<any> {
  public render() {
    const error = this.props.error
    return (
      <TitleCard title={'TkHeaders Error'} icon={'console'}>
        <Container>
          <pre>
            <code>{error}</code>
          </pre>
        </Container>
      </TitleCard>
    )
  }
}

export default ErrorLog
const Container = styled.div`
  background-color: ${colors.darkBlack};
  overflow: auto;
  padding: 1rem;
  margin: -12px -24px -24px -24px;
  font-size: 0.9rem;
  line-height: 1.2rem;
  position: relative;
  z-index: 2;
  border-radius: 0 0 5px 5px;
  color: rgba(255, 255, 255, 0.9);
`
